import { render, staticRenderFns } from "./DeliveredOrdersTable.vue?vue&type=template&id=7471297e&scoped=true"
import script from "./DeliveredOrdersTable.vue?vue&type=script&lang=js"
export * from "./DeliveredOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./DeliveredOrdersTable.vue?vue&type=style&index=0&id=7471297e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7471297e",
  null
  
)

export default component.exports